import {omneticApi as api} from '@dms/api/base';

import {DashboardsV2ApiResponse, DashboardsV2ApiArg} from './types';

const goodDataApi = api.injectEndpoints({
  endpoints: (build) => ({
    dashboardsV2: build.query<DashboardsV2ApiResponse, DashboardsV2ApiArg>({
      query: () => ({
        url: `/dms/v2/gooddata/dashboards`,
      }),
    }),
  }),
});

export const {useDashboardsV2Query} = goodDataApi;
